import { useSelector } from "react-redux";
import { useGetIntegrationExternalSystemsQuery } from "../store/apiSlice/integrationApiSlice";
import { isXeroConnected } from "../utils/xeroIntegration";

export const useXeroConnected = () => {
  useGetIntegrationExternalSystemsQuery();
  const externalSystems = useSelector(state => state.integration?.externalSystems);
  return isXeroConnected(externalSystems);
};
